// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ThumbsUpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ThumbsUpIcon" ref={forwardedRef} {...props}>
      <path d="M11.898 4.714 11.5 7.5H16a1 1 0 0 1 1 1v2.268a1 1 0 0 1-.106.447l-2.618 5.232A1 1 0 0 1 13.382 17H6V7.5L10 3l1.355.678a1 1 0 0 1 .543 1.036M13.073 15.5l2.427-4.85V9H9.77l.592-4.142-.005-.002L7.5 8.07v7.43z" />
      <path d="M3 7.5V17h1.498V7.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ThumbsUpIcon = /* @__PURE__ */ Object.assign(
  ThumbsUpIconComponent,
  { displayName: 'ThumbsUpIcon' },
);
